'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ ["$cookies", "ProjectService", "ConfigService", function ($cookies, ProjectService, ConfigService) {
    var factory = {};
    var secureCookies = ConfigService.get('secureCookies');


    factory.setIntegratedConsoleStatus = function(projects) {
        if (projects) {
            var integratedConsole = !!projects.find(project => project.id === 0);
            $cookies.put('nomad.noc.ng.integratedConsole', integratedConsole, {secure: secureCookies});
            var hasExistingDefaultProject = !!projects.find(project => project.id == factory.getDefaultProjectId());
            if (integratedConsole && !hasExistingDefaultProject) {
                projects = projects.filter(project => project.id !== 0);
                if (projects && projects.length > 0) {
                    factory.setDefaultProjectId(projects[0].id)
                }
            }
        }
    }

    factory.isIntegratedConsole = function() {
        var integratedConsole = $cookies.get('nomad.noc.ng.integratedConsole');
        return integratedConsole === "true";
    }

    factory.setDefaultProjectId = function (id) {
        $cookies.put('nomad.noc.ng.defaultProjectId', id, {secure: secureCookies});
    };

    factory.getDefaultProjectId = function () {
        return $cookies.get('nomad.noc.ng.defaultProjectId');
    };

    factory.setProjectId = function (id) {
        var cookieProjectId;
        if (id && id.toString().includes(',')) {
            cookieProjectId = id.split(',').join('-');
        } else {
            cookieProjectId = id;
        }
        $cookies.put('nomad.noc.ng.projects', cookieProjectId, {secure: secureCookies});
    };

    factory.getProjectId = function () {
        var cookieProjectId = $cookies.get('nomad.noc.ng.projects');
        if (cookieProjectId && cookieProjectId.toString().includes('-')) {
            return cookieProjectId.split('-').join(',');
        } else {
            return cookieProjectId;
        }
       
    };

    factory.propagateProjectId = function () {
        var id = factory.getProjectId();
        if (util.isDefined(id)) {
            ProjectService.setSelectedProjectById(id, "C00KIE");
        }
        return id;
    };
    factory.hasCookie = function(projectId){
        var oldCookieProjectId = this.getProjectId();
        var newCookieProjectId = projectId;
        
        var cookieProjectIds = oldCookieProjectId ?  (oldCookieProjectId.includes(',') ? oldCookieProjectId.split(',') : [oldCookieProjectId]) : [];
        var userProjectIds = newCookieProjectId ?  (newCookieProjectId.includes(',') ? newCookieProjectId.split(',') : [newCookieProjectId]) : [];

        var hasAccessToCookieProjects = true;
        cookieProjectIds.forEach(projectId => {
            hasAccessToCookieProjects = hasAccessToCookieProjects && !!userProjectIds.find(userProjectId => userProjectId === projectId);
        });

        return oldCookieProjectId && hasAccessToCookieProjects;
    };
    return factory;
}];